import { FeatureFlagState, FeatureFlagUseCase } from '@ibk/shared-types';
import { CONTABIL_COMPANY_LINK_COMPLETED_KEY, CONTABIL_COMPANY_LINK_SKIPPED_KEY, } from '../contabilCompanyLink.constants';
export function hasSkippedContabilCompanyLink() {
    return sessionStorage.getItem(CONTABIL_COMPANY_LINK_SKIPPED_KEY) === 'true';
}
export function hasCompletedContabilCompanyLink() {
    return sessionStorage.getItem(CONTABIL_COMPANY_LINK_COMPLETED_KEY) === 'true';
}
export function shouldShowContabilCompanyLink(requiresAction) {
    return requiresAction && !hasSkippedContabilCompanyLink() && !hasCompletedContabilCompanyLink();
}
export function shouldShowContabilCompanyLinkPendingBanner(isUnlinked) {
    return isUnlinked && !hasCompletedContabilCompanyLink();
}
export function isIntegrationFeatureFlagDisabledError(error) {
    if (!error || typeof error !== 'object') {
        return false;
    }
    const err = error;
    const code = err.code ?? err.data?.code ?? err.details?.code;
    return err.status === 403 && code === 'FEATURE_NOT_ENABLED';
}
export function isPlatformAccountantIntegrationSgdActive(flags) {
    const flag = flags?.find(item => item.usecase === FeatureFlagUseCase.PLATFORM_ACCOUNTANT_INTEGRATION_SGD);
    return flag?.state === FeatureFlagState.WHITELISTED;
}
